export interface ValidationErrorsResponse {
  message: string;
  errors: Record<string, string[]>; // e.g. { "fields_data.329542.value": ["error msg"] }
}

export enum ValidationErrorPrefix {
  FieldsData = 'fields_data',
  Data = 'data'
}